import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DeleteBinIcon, AddPlusIcon } from '../../../../assets/icons';
import { Form } from '../../../../shared/components';
import Text from '../../../../shared/components/Text';

import { countries, USA } from '../../../../shared/constants';
import { styleUtils, formUtils } from '../../../../shared/utils';

import {
  formSchema,
  invoiceSchema,
  validationSchema,
  separateInvoiceValidationSchema
} from './schemas';

import styles from './styles';
import {ROUTES} from "../../../../shared/constants/navigation";
import {BILLING_FREQUENCE_OPTIONS, DEFAULT_SERVICE_PERIOD} from "../../../../shared/constants/common";

const ALLOW_SEPARATE_INVOICE = false; // Disabled for now

const { style } = styleUtils;
const { getOptions } = formUtils;

const Container = style('div', styles.container);
const CreateSeparateInvoiceContainer = style(
  'div',
  styles.createSeparateInvoiceContainer
);
const AddIcon = style(AddPlusIcon, styles.addPlusIcon);
const LabelContainer = style('div', styles.labelContainer);
const CreateSeparateInvoiceLabel = style(
  Text,
  styles.createSeparateInvoiceLabel
);

const OPTIONS = (t, props) => {
  const { formData: {instances: {instances: { instancesSetup } = {} } = {} } = {} } = props;
  const { servicePeriod = DEFAULT_SERVICE_PERIOD } = instancesSetup || {};

  const billingFrequenceOptions = [...BILLING_FREQUENCE_OPTIONS].filter(item => item <= parseInt(servicePeriod));
  const billingFrequency = getOptions(t, 'billingFrequency', billingFrequenceOptions);
  const billingCurrency = getOptions(t, 'billingCurrency', [
    'usd',
    'euro',
    'gbp',
    'nok'
  ]);
  return {
    countries,
    billingFrequency,
    billingCurrency
  };
};

const SCHEMAS = {
  1: formSchema,
  2: invoiceSchema
};

const VALIDATION_SCHEMAS = {
  1: validationSchema,
  2: separateInvoiceValidationSchema
};

class BillingInformation extends Component {
  constructor(props) {
    super(props);
    const { t, data } = props;
    this.state = {
      ...data,
      options: OPTIONS(t, this.props),
      triggerFormInitialValues: false
    };
    this.isCountryUSA = data ? data['country'] === 'United States' : false;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { i18n, t } = this.props;
    if (i18n.language !== prevProps.i18n.language)
      this.setState({ options: OPTIONS(t, this.props) });
  }

  handleOnDeleteSeparateInvoice = () => {
    const { handleOnDataChange, removeFromMultiForm } = this.props;
    removeFromMultiForm(2);
    handleOnDataChange('separateInvoiceActive', false);
  };

  handleOnCreateSeparateInvoiceClick = () => {
    const { handleOnDataChange } = this.props;
    handleOnDataChange('separateInvoiceActive', true);
  };

  handleOnChange = (field, value) => {
    const { handleOnDataChange } = this.props;
    handleOnDataChange(field, value);
    if (field === 'differentBillingActive') this.update = true;
  };

  trigger = formId => {
    if (formId !== 2) return;
    const shouldUpdate = this.update;
    this.update = false;
    return shouldUpdate;
  };

  triggerUpdateInitialValues = () => {
    const { data } = this.props;
    const shouldUpdate = data
      ? (data['country'] === USA) !== this.isCountryUSA
      : false;
    this.isCountryUSA = data['country'] === USA;
    return shouldUpdate;
  };

  render() {
    const {
      t,
      history,
      data,
      formData,
      instancesDescription
    } = this.props;
    const { options } = this.state;
    const isSeparateInvoiceActive = !!data['separateInvoiceActive'];
    const forms =
      isSeparateInvoiceActive && ALLOW_SEPARATE_INVOICE ? [1, 2] : [1];
    const addOns = { ...formData.addOns };
    const hasIntegrationDriver = addOns && addOns.integrationDriver;
    const hasDhis2SupportPlan = !!(addOns && addOns.dhis2SupportPlan);

    return (
      <Container>
        {forms.map(id => {
          const lastForm = id === forms.length;
          const schema = SCHEMAS[id];
          const validSchema = VALIDATION_SCHEMAS[id];
          const descriptions = id === 2 ? instancesDescription : '';
          const forceName = id === 2 ? 'differentBilling' : '';
          return (
            <Form
              // updateInitialValues={this.trigger(id)}
              updateInitialValues={this.triggerUpdateInitialValues()}
              formId={id}
              key={id}
              isMultiForm
              onChange={this.handleOnChange}
              validationSchema={validSchema(t, data, forceName, {}, {options})}
              formSchema={schema(options, t, data, descriptions, {
                hasIntegrationDriver,
                hasDhis2SupportPlan
              })}
              title={t(`title.${id}`)}
              previousButton={{
                label: t('previousButtonLabel'),
                action: () => history.push(ROUTES.SIGN_UP_ADD_ONS),
              }}
              nextButton={{
                label: t('nextButtonLabel'),
                action: () => history.push(ROUTES.SIGN_UP_ORDER_DETAILS)
              }}
              topButton={
                Number(id) !== 1
                  ? {
                      icon: <DeleteBinIcon />,
                      action: this.handleOnDeleteSeparateInvoice
                    }
                  : null
              }
              showFormButtons={lastForm}
              bottomComponent={
                ALLOW_SEPARATE_INVOICE &&
                lastForm &&
                !isSeparateInvoiceActive ? (
                  <CreateSeparateInvoice
                    t={t}
                    onClick={this.handleOnCreateSeparateInvoiceClick}
                  />
                ) : null
              }
            />
          );
        })}
      </Container>
    );
  }
}

const CreateSeparateInvoice = ({ t, onClick }) => (
  <CreateSeparateInvoiceContainer onClick={onClick}>
    <AddIcon />
    <LabelContainer>
      <CreateSeparateInvoiceLabel size="large">
        {t('createSeparateInvoiceLabel')}
      </CreateSeparateInvoiceLabel>
    </LabelContainer>
  </CreateSeparateInvoiceContainer>
);

BillingInformation.propTypes = {
  handleOnDataChange: PropTypes.func,
  handlePreviousStepClick: PropTypes.func,
  handleNextStepClick: PropTypes.func,
  instancesDescription: PropTypes.array,
  data: PropTypes.object.isRequired
};

BillingInformation.defaultProps = {
  data: {}
};

export default BillingInformation;
